import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./Components/Navbar";

import Login from "./Pages/Auth/Login";
import Home from "./Pages/Home/Home";
import { ToastContainer } from "react-toastify";
import { SettingsProvider } from "./context/SettingsContext";
import Employees from "./Pages/Employees/Employees";
import DiscountRewards from "./Pages/DiscountReward/DiscountRewards";
import Expenses from "./Pages/Expenses/Expenses";
import Categories from "./Pages/Categories/Categories";
import Services from "./Pages/Services/Services";
import Customers from "./Pages/Customers/Customers";
import EmployeeWithdraws from "./Pages/EmployeeWithdraws/EmployeeWithdraws";
import MoneyInvoices from "./Pages/MoneyInvoices/MoneyInvoices";
import Invoices from "./Pages/Invoices/Invoices";
import IncomeStatement from "./Pages/Reports/IncomeStatement";
import Cash from "./Pages/Reports/Cash";
import TaxesReport from "./Pages/Reports/TaxesReport";
import ServicesExpenses from "./Pages/Reports/ServicesExpenses";
import AccountStatement from "./Pages/Reports/AccountStatement";
import Salary from "./Pages/Salary/Salary";
import EmployeeDetails from "./Pages/EmployeeDetails/EmployeeDetails";
import SubUsers from "./Pages/SubUseres/SubUsers";
import Register from "./Pages/Auth/Register";
import OwnerWithdrawl from "./Pages/OwnerWithdrawl/OwnerWithdrawl";
import UserPermissions from "./Pages/Permissions/UserPermissions";
import SubAdmins from "./Pages/Dashboard/SubAdmins";
import AdminLayout from "./AdminLayout";
import ProtectedLayout from "./Api/ProtectedRoute";
import AdminPermissions from "./Pages/Dashboard/AdminPermissions";
import SubscriptionsDetails from "./Pages/SubscriptionsDetails/SubscriptionsDetails";

import { Outlet } from "react-router-dom";
import Subscriptions from "./Pages/Subscriptions/Subscriptions";
import Can from "./Components/Can";
import { PermissionProvider } from "./context/PermissionContext";
import { AuthProvider } from "./context/AuthContext";
import Settings from "./Pages/Settings/Settings";
import CashTransfer from "./Pages/CashTransfer/CashTransfer";
import Landing from "./Landing/Landing";
import Dashboard from "./Pages/ClientDashboard/Dashboard";
import Licences from "./Pages/Licences/Licences";
import Test from "./Pages/Test";
import InvoiceDetails from "./Pages/InvoiceDetails";

function Layout() {
  return (
    <>
      <Navbar />
      <div className="page-content">
        <Outlet />
      </div>
    </>
  );
}

function App() {
  const location = useLocation();
  // const noContextRoutes = ["/login", "/register", "/landing"];
  const noContextRoutes = ["/login", "/register", "/"];

  const isPublicInvoice = location.pathname.startsWith("/invoice/");
  return (
    <>
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <Routes>
        {/* للطباعه */}
        <Route path="/invoice/:uuid" element={<InvoiceDetails />} />
      </Routes>
      {noContextRoutes.includes(location.pathname) || isPublicInvoice ? (
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          {/* <Route path="/landing" element={<Landing />} /> */}
          <Route path="/" element={<Landing />} />
        </Routes>
      ) : (
        <PermissionProvider>
          <AuthProvider>
            <SettingsProvider>
              <Routes>
                <Route
                  element={
                    <ProtectedLayout allowedTypes={["admin", "subadmin"]} />
                  }>
                  <Route element={<AdminLayout />}>
                    <Route path="/admin/sub-admins" element={<SubAdmins />} />
                    <Route
                      path="/admin/admin-permissions/:uuid"
                      element={
                        <Can permission="admin_permission_show">
                          <AdminPermissions />{" "}
                        </Can>
                      }
                    />
                    <Route
                      path="/admin/subscriptions"
                      element={
                        <Can permission="subscriber_show">
                          <Subscriptions />{" "}
                        </Can>
                      }
                    />
                    <Route
                      path="/admin/subscribtions-details"
                      element={
                        <Can permission="admin_show">
                          <SubscriptionsDetails />{" "}
                        </Can>
                      }
                    />
                  </Route>
                </Route>

                <Route
                  element={
                    <ProtectedLayout allowedTypes={["user", "subuser"]} />
                  }>
                  <Route element={<Layout />}>
                    {/* <Route path="/" element={<Home />} /> */}
                    <Route
                      path="/employees"
                      element={
                        <Can permission="employee_show">
                          {" "}
                          <Employees />{" "}
                        </Can>
                      }
                    />
                    <Route
                      path="/test"
                      element={
                        <Can permission="employee_show">
                          {" "}
                          <Test />{" "}
                        </Can>
                      }
                    />
                    <Route
                      path="/discount-rewards"
                      element={
                        <Can permission="empAdjustment_show">
                          <DiscountRewards />{" "}
                        </Can>
                      }
                    />
                    <Route
                      path="/expenses"
                      element={
                        <Can permission="expense_show">
                          <Expenses />{" "}
                        </Can>
                      }
                    />
                    <Route
                      path="/categories"
                      element={
                        <Can permission="category_show">
                          <Categories />{" "}
                        </Can>
                      }
                    />
                    <Route
                      path="/services"
                      element={
                        <Can permission="service_show">
                          <Services />{" "}
                        </Can>
                      }
                    />
                    <Route
                      path="/licences"
                      element={
                        <Can permission="service_show">
                          <Licences />{" "}
                        </Can>
                      }
                    />
                    <Route
                      path="/customers"
                      element={
                        <Can permission="customer_show">
                          <Customers />{" "}
                        </Can>
                      }
                    />
                    <Route
                      path="/employeewithdraws"
                      element={
                        <Can permission="customer_show">
                          <EmployeeWithdraws />{" "}
                        </Can>
                      }
                    />
                    <Route
                      path="/invoices"
                      element={
                        <Can permission="invoice_show">
                          <Invoices />{" "}
                        </Can>
                      }
                    />
                    <Route
                      path="/money-invoices"
                      element={
                        <Can permission="money_invoice_show">
                          <MoneyInvoices />{" "}
                        </Can>
                      }
                    />
                    <Route
                      path="/income-statement"
                      element={
                        <Can permission="income_statement_show">
                          <IncomeStatement />{" "}
                        </Can>
                      }
                    />
                    <Route
                      path="/cash"
                      element={
                        <Can permission="cash_report_show">
                          <Cash />{" "}
                        </Can>
                      }
                    />
                    <Route
                      path="/account-statement"
                      element={
                        <Can permission="account_statement_show">
                          <AccountStatement />{" "}
                        </Can>
                      }
                    />
                    <Route
                      path="/services-expenses"
                      element={<ServicesExpenses />}
                    />
                    <Route path="/taxes-report" element={<TaxesReport />} />
                    <Route
                      path="/salary"
                      element={
                        <Can permission="salary_show">
                          <Salary />{" "}
                        </Can>
                      }
                    />

                    <Route
                      path="/salary-details/:uuid"
                      element={<EmployeeDetails />}
                    />

                    <Route
                      path="/sub-users"
                      element={
                        <Can permission="sub_user_show">
                          {" "}
                          <SubUsers />{" "}
                        </Can>
                      }
                    />
                    <Route
                      path="/owner-withdrawl"
                      element={
                        <Can permission="owner_withdrawl_show">
                          <OwnerWithdrawl />{" "}
                        </Can>
                      }
                    />
                    <Route
                      path="/user-permissions/:uuid"
                      element={
                        <Can permission="permission_show">
                          <UserPermissions />{" "}
                        </Can>
                      }
                    />
                    <Route
                      path="/settings"
                      element={
                        <Can permission="setting_show">
                          <Settings />
                        </Can>
                      }
                    />
                    <Route
                      path="/cash-transfer"
                      element={
                        <Can permission="cash_transfer_show">
                          <CashTransfer />
                        </Can>
                      }
                    />

                    <Route
                      path="/dashboard"
                      element={
                        <Can permission="cash_transfer_show">
                          <Dashboard />
                        </Can>
                      }
                    />
                  </Route>
                </Route>
              </Routes>
            </SettingsProvider>
          </AuthProvider>
        </PermissionProvider>
      )}
    </>
  );
}

export default App;
